import { render, staticRenderFns } from "./PDFHTMLRecordEditor.vue?vue&type=template&id=a460cc2e&"
import script from "./PDFHTMLRecordEditor.vue?vue&type=script&lang=js&"
export * from "./PDFHTMLRecordEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports